/* eslint-disable camelcase */
export var ESensor;
(function (ESensor) {
    ESensor["CO2"] = "CO2";
    ESensor["Flow"] = "Flow";
    ESensor["Humidity"] = "Humidity";
    ESensor["Motion"] = "Motion";
    ESensor["Pressure"] = "Pressure";
    ESensor["RelayState"] = "RelayState";
    ESensor["Temperature"] = "Temperature";
    ESensor["VOC"] = "VOC";
    ESensor["ValveFlowPercentage"] = "ValveFlowPercentage";
    ESensor["CurrentPower"] = "CurrentPower";
    ESensor["CurrentPowerPhase"] = "CurrentPowerPhase";
    ESensor["TotalPower"] = "TotalPower";
    ESensor["TotalPowerPhase"] = "TotalPowerPhase";
    ESensor["Voltage"] = "Voltage";
    ESensor["Current"] = "Current";
    ESensor["TotalGas"] = "TotalGas";
    ESensor["CurrentWaterFlow"] = "CurrentWaterFlow";
    ESensor["TotalWater"] = "TotalWater";
})(ESensor || (ESensor = {}));
export var EDeviceEntity;
(function (EDeviceEntity) {
    EDeviceEntity["Sensor"] = "Sensor";
    EDeviceEntity["Input"] = "Input";
    EDeviceEntity["Relay"] = "Relay";
    EDeviceEntity["Modbus"] = "Modbus";
})(EDeviceEntity || (EDeviceEntity = {}));
export var ERoomState;
(function (ERoomState) {
    ERoomState["ACTIVE"] = "Active";
    ERoomState["INACTIVE"] = "Inactive";
})(ERoomState || (ERoomState = {}));
export var ETimeFrame;
(function (ETimeFrame) {
    ETimeFrame["HOUR"] = "hour";
    ETimeFrame["DAY"] = "day";
    ETimeFrame["WEEK"] = "week";
})(ETimeFrame || (ETimeFrame = {}));
export var ESetPoint;
(function (ESetPoint) {
    ESetPoint["LightSetpoint"] = "LightSetpoint";
    ESetPoint["MaxTemperature"] = "MaxTemperature";
    ESetPoint["MinTemperature"] = "MinTemperature";
    ESetPoint["PowerSetpoint"] = "PowerSetpoint";
    ESetPoint["TemperatureMode"] = "TemperatureMode";
    ESetPoint["VentilationFlowSetpoint"] = "VentilationFlowSetpoint";
    ESetPoint["ValveFlowPercentageSetpoint"] = "ValveFlowPercentageSetpoint";
})(ESetPoint || (ESetPoint = {}));
